import React, { useState } from 'react';
import '../../css/JuanIS/JuanISPayBills.css';

function JuanISPayBills({ onBack }) {
  const [amount, setAmount] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!agreedToTerms) {
      alert('Please agree to the Terms & Conditions and Data Privacy Policy');
      return;
    }
    // Handle payment submission
  };

  return (
    <div className="juanis-pay-bills-container">
      <h1>Pay Bills</h1>

      <div className="juanis-pay-bills-notification-banner">
        <p>The "Pay Bills" section marks the final step to officially secure your place as a student. Complete your payment now and take the last exciting step toward beginning your journey with us!</p>
      </div>

      <div className="juanis-pay-bills-reminders-section">
        <h3>Reminders:</h3>
        <ul>
          <li>You can pay your tuition in person at the Accounting Office or choose to pay online.</li>
          <li>Select your preferred mode of payment: Full payment or Installment plan.</li>
          <li>Once your payment is validated, your status will be updated, and you will receive a notification confirming your enrollment.</li>
        </ul>
      </div>

      <div className="juanis-pay-bills-payment-form">
        <div className="juanis-pay-bills-amount-section">
          <label>Amount to Pay:</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter amount"
            className="juanis-pay-bills-amount-input"
          />
        </div>

        <div className="juanis-pay-bills-payment-summary">
          <h3>Payment Summary</h3>
          <div className="juanis-pay-bills-summary-item">
            <span>Amount to Pay:</span>
            <span>₱ {amount || '0.00'}</span>
          </div>
        </div>

        <div className="juanis-pay-bills-payment-method-section">
          <h3>Choose Payment Method:</h3>
          <div className="juanis-pay-bills-payment-methods">
            <div className="juanis-pay-bills-payment-method-group">
              <label className="juanis-pay-bills-payment-method-option">
                <input
                  type="radio"
                  name="paymentMethod"
                  value="card"
                  checked={paymentMethod === 'card'}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                <img src="/path-to-card-logos.png" alt="Credit/Debit Cards" />
                <span>Credit/Debit Cards</span>
              </label>
            </div>
            <div className="juanis-pay-bills-payment-method-group">
              <label className="juanis-pay-bills-payment-method-option">
                <input
                  type="radio"
                  name="paymentMethod"
                  value="gcash"
                  checked={paymentMethod === 'gcash'}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                <img src="/path-to-gcash-logo.png" alt="GCash" />
                <span>GCash</span>
              </label>
            </div>
          </div>
        </div>

        <div className="juanis-pay-bills-terms-section">
          <label className="juanis-pay-bills-terms-checkbox">
            <input
              type="checkbox"
              checked={agreedToTerms}
              onChange={(e) => setAgreedToTerms(e.target.checked)}
            />
            <span>
              I agree to the{' '}
              <a href="#terms" className="juanis-pay-bills-terms-link">Terms & Conditions</a>
              {' '}and{' '}
              <a href="#privacy" className="juanis-pay-bills-terms-link">Data Privacy Policy</a>
            </span>
          </label>
        </div>

        <div className="juanis-pay-bills-action-buttons">
          <button 
            className="juanis-pay-bills-back-btn" 
            onClick={onBack}
          >
            Back
          </button>
          <button 
            className="juanis-pay-bills-proceed-btn" 
            onClick={handleSubmit}
            disabled={!amount || !paymentMethod || !agreedToTerms}
          >
            Proceed to Payment
          </button>
        </div>
      </div>
    </div>
  );
}

export default JuanISPayBills;